























import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'
import { Route } from 'vue-router'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import BaseLayout from '@/layout/BaseLayout.vue'
import TabsPanel from '@/components/Common/TabsPanel.vue'
import UserRow from '@/components/User/UserRow.vue'
import UsersFilter from '@/components/User/UsersFilter.vue'
import UserInviteButton from '@/components/User/UserInviteButton.vue'
import store from '@/store'
import { UserActionTypes } from '@/store/modules/users/actions'
import { CompanyUser, UserInvitation, UserScope } from '@/models/users'

interface Computed {
  users: CompanyUser[]
  invitations: UserInvitation[]
}

async function updateData(to: Route, from: Route, next: () => void) {
  const requiredData = [
    store.dispatch(UserActionTypes.FetchCompanyUsers),
    store.dispatch(UserActionTypes.FetchRoles),
  ]
  if (store.getters.canDoScope(UserScope.Users)) {
    requiredData.push(store.dispatch(UserActionTypes.FetchInvitations))
  }
  await Promise.all(requiredData)
  next()
}

export default mixins(WindowResizeListener).extend<{}, {}, Computed, {}>({
  beforeRouteEnter: updateData,
  components: {
    BaseLayout,
    TabsPanel,
    UserRow,
    UsersFilter,
    UserInviteButton,
  },
  computed: {
    ...mapGetters({
      users: 'getUsersFilteredList',
      invitations: 'getInvitationsList',
    }),
  },
  metaInfo() {
    return { title: this.$tc('settings.users') }
  },
})
